module.exports = __webpack_public_path__ + "static/img/net.80b4bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/net.jpg
// module id = MZu/
// module chunks = 0